import axios from 'axios';

import locale from './locale.json';

import { message_azure_to_minsait } from './ConversorMessages.js'

let restBot = "";
let WATERMARK = 0;
const restBotDES = process.env.REACT_APP_REST_BOT_DES;
const restBotPRE = process.env.REACT_APP_REST_BOT_PRE;
const restBotPRO = process.env.REACT_APP_REST_BOT_PRO;
const is_apim = process.env.REACT_APP_APIM;
const tokenDirectLine = process.env.REACT_APP_TOKEN_DIRECT_LINE;
const apiTokenDES = process.env.REACT_APP_API_TOKEN_DES;
const apiTokenPRE = process.env.REACT_APP_API_TOKEN_PRE;
const apiTokenPRO = process.env.REACT_APP_API_TOKEN_PRO;
const frontEnv = process.env.REACT_APP_ENV;

let headers = {}
if (is_apim) {
  if (frontEnv === "DES") {
    headers = {
      headers: {
        "Ocp-Apim-Subscription-Key": apiTokenDES,
      }
    };
    restBot = restBotDES;
  }
  else if (frontEnv === "PRE") {
    headers = {
      headers: {
        "Ocp-Apim-Subscription-Key": apiTokenPRE,
      }
    };
    restBot = restBotPRE;
  }
  else {
    headers = {
      headers: {
        "Ocp-Apim-Subscription-Key": apiTokenPRO,
      }
    };
    restBot = restBotPRO;
  }
} else {
  headers = {
    headers: {
      "Authorization": "Bearer " + tokenDirectLine
    }
  };
}


export async function start_new_conversation() {
  //console.log("start_new_conversation")
  let endpoint = ''
  if (is_apim) {
    endpoint = '/conversations/start'
  } else {
    endpoint = '/v3/directline/conversations'
  }
  let { response } = await backendPost(restBot + endpoint, headers)
  let conversationId = response["conversationId"];
  let conversation_token = response["token"];
  //console.log("coneversation_id:"+conversationId)
  if (!is_apim) {
    conversation_token = "Bearer " + conversation_token
  }
  //console.log("conversation_token:"+conversation_token)
  return { conversationId, conversation_token };
}

//Send an activity
export async function messageCall(message, user_id, conversation_id, conversation_token) {
  const data = {
    text: message,
    from: {
      id: user_id
    },
    type: 'message'
  }
  let endpoint = ""
  if (is_apim) {
    endpoint = `/conversations/activities/send?conversation_id=${conversation_id}`
    headers["headers"]["bf-token"] = conversation_token
  } else {
    endpoint = `/v3/directline/conversations/${conversation_id}/activities`
    headers["headers"]["Authorization"] = conversation_token
  }
  let { response, status } = await backendPost(restBot + endpoint, headers, data)
  //console.log(response)
  if (status === 200) {
    let activity_id = response['id']
    response = await polling_activity(headers, conversation_id, activity_id)
  }
  return { response, status };
}

export async function eventsCall(event_id, user_id, conversation_id, conversation_token, value = '') {
  let data = {
    name: event_id,
    from: {
      id: user_id
    },
    type: "event",
    value: value
  }
  let endpoint = ""
  if (is_apim) {
    endpoint = `/conversations/activities/send?conversation_id=${conversation_id}`
    headers["headers"]["bf-token"] = conversation_token
  } else {
    endpoint = `/v3/directline/conversations/${conversation_id}/activities`
    headers["headers"]["Authorization"] = conversation_token
  }
  let { response, status } = await backendPost(restBot + endpoint, headers, data)
  //console.log(response)
  if (status === 200) {
    let activity_id = response['id']
    response = await polling_activity(headers, conversation_id, activity_id)
  }
  //console.log(response)
  return response
}

export async function polling_activity(headers, conversation_id, activity_id) {
  let response_activity = [];
  let success = false;
  let intentos = 0;
  let endpoint = ""
  if (is_apim) {
    endpoint = `/conversations/activities/receive?conversation_id=${conversation_id}&watermark=${WATERMARK}`
  } else {
    endpoint = `/v3/directline/conversations/${conversation_id}/activities?watermark=${WATERMARK}`
  }
  while (intentos < 5 && !success) {
    let { response } = await backendGet(restBot + endpoint, headers)
    if (response && "activities" in response) {
      let activities = response["activities"]
      for (const activity of activities) {
        if (activity["replyToId"] === activity_id) {
          message_azure_to_minsait(response_activity, activity)
          if (response["watermark"] >= 50) {
            WATERMARK = response["watermark"]
          }
          success = true
        }
      }
    }
    await sleep(500)
    intentos++;
  }
  if (response_activity.length === 0) {
    response_activity = [{
      answer: locale["es"].error500,
      type: "text",
      data: {}
    }];
  }
  return response_activity;
}

async function backendPost(url, post_headers, data = {}) {
  let response;
  let status;
  try {
    response = await axios.post(url, data, post_headers);
    status = response.status;
    response = response.data;
  }
  catch (error) {
    status = error.response.status
    response = null

    if (status === 400) {
      response = [{
        answer: locale["es"].error400,
        type: "text",
        data: {}
      }];
    }
    else if (status === 403) {
      response = [{
        answer: locale["es"].error403,
        type: "text",
        data: {}
      }];
    }
    else {
      response = [{
        answer: locale["es"].error500,
        type: "text",
        data: {}
      }];
    }
  }

  return { response, status };
}

async function backendGet(url, headers) {
  let response;
  let status;
  try {
    response = await axios.get(url, headers);

    status = response.status;
    response = response.data;
    return { response, status };
  }
  catch (error) {
    response = error.response;
    return { "response": null };
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}